import WidgetEntity from '../WidgetEntity';
import * as Widgets from '@mm/constants/widgets';

export default class extends WidgetEntity {
  static make(pageId: number, sortOrder: number) {
    const widget = {
      ...super.make(pageId, Widgets.TYPING, 'Untitled', sortOrder),
      config: {
        seconds: 2,
      },
    };

    return widget;
  }
}
